import _ from 'lodash'
import nuxtStorage from 'nuxt-storage'

export const tools = {
  getUserComingSoonMessage(user, vm) {
    const phone = user && user.phone ? user.phone : null
    const email = user && user.email ? user.email : null
    const firstName = user && user.firstName ? user.firstName : null
    const lastName = user && user.lastName ? user.lastName : null
    let message = vm.$t('reservation.labels.no_payment_process')
    if (phone || email) {
      message =
        message +
        '<BR/>' +
        vm.$t('reservation.labels.no_payment_process_contact_teacher')
      if (firstName || lastName) {
        message = message + '('
        message = firstName ? message + firstName + ' ' : message + ' '
        message = lastName ? message + lastName : message
        message = message + ') '
      }
      message = phone ? message + phone : message
      message = phone && email ? message + '/' : message
      message = email
        ? message + "<a href='mailto:" + email + "'>" + email + '</a>'
        : message
      return message
    }
  },

  getSaasBaseUrl(theme) {
    switch (theme) {
      case 'goyoga':
        return process.env.SASS_GY_URL
      case 'gopilates':
        return process.env.SASS_GP_URL
      case 'gotherapy':
        return process.env.SASS_GT_URL
      default:
        return process.env.SASS_GY_URL
    }
  },

  getCategory(theme) {
    switch (theme) {
      case 'goyoga':
        return 'cours-yoga'
      case 'gopilates':
        return 'cours-pilates'
      case 'gotherapy':
        return 'rendez-vous-therapeute'
      default:
        return 'session'
    }
  },

  getTranslationExactLanguage(item, param, lang, trLangParam = 'lang') {
    try {
      let result = ''
      const translation = item.translations.find((t) => t[trLangParam] === lang)
      if (_.has(translation, param)) {
        result = translation[param]
      }
      return result
    } catch (error) {
      // eslint-disable-next-line
      console.log('error getTranslation: ' + JSON.stringify(error))
      return ''
    }
  },

  getTranslation(item, param, lang, trLangParam = 'lang') {
    try {
      let result = ''
      const translation =
        item.translations.find((t) => t[trLangParam] === lang) ||
        item.translations[0]
      if (_.has(translation, param)) {
        result = translation[param]
      } else {
        item.translations.forEach((tr) => {
          if (_.has(tr, param)) {
            result = tr[param]
          }
        })
      }
      return result
    } catch (error) {
      // eslint-disable-next-line
      console.log('error getTranslation: ' + JSON.stringify(error))
      return ''
    }
  },

  getArticleOwnerLink(article, lang, isWL) {
    if (
      !(
        article.createdBy &&
        article.createdBy.teacher &&
        article.createdBy.teacher.slug
      )
    )
      return false
    let link = false
    if (!isWL) {
      link =
        '/' +
        lang +
        '/p/' +
        article.createdBy.teacher.slug +
        '/' +
        article.createdBy.id
    } else {
      link =
        '/' +
        lang +
        '/p/' +
        article.createdBy.teacher.slug +
        '/' +
        tools.getTranslation(article.discipline, 'name', lang) +
        '/' +
        article.createdBy.id
    }
    return link
  },

  getArticleLink(article, lang) {
    const slug = tools.getTranslation(article, 'slug', lang)
    return '/' + lang + '/blog/' + slug + '/' + article.id
  },

  getArticleCanonical(article, lang) {
    if (article.publicSiteShare && article.publicSiteShare.length > 0) {
      try {
        const site = article.publicSiteShare[0].site
        const canonical =
          'https://www.' + site.domain + tools.getArticleLink(article, lang)
        return canonical
      } catch (error) {
        // eslint-disable-next-line
        console.log('getArticleCanonical error: ' + JSON.stringify(error))
        return false
      }
    } else return false
  },

  getServiceLink(service, theme, lang, reserve) {
    const slug = (
      service.translations.find((l) => l.lang === lang) ||
      service.translations[0]
    ).slug
    let path =
      this.getSaasBaseUrl(theme) +
      lang +
      '/' +
      this.getCategory(theme) +
      '/' +
      slug +
      '/' +
      service.id
    if (reserve) path += '/reserve'
    return path
  },

  getServiceName(service, lang) {
    return tools.getTranslation(service, 'name', lang)
  },

  getServiceDesc(service, lang) {
    return tools.getTranslation(service, 'desc', lang)
  },

  getServiceImage(service) {
    if (service.images && service.images[0])
      return service.images[0].webPath
        .replace('http', 'https')
        .replace('/files/', '/media/390/')
    else return require('~/static/img/service-default-w390.jpg')
  },

  getServiceDisciplines(item, lang, vm) {
    if (item && item.disciplines && item.disciplines.length > 0) {
      const disciplines = []
      item.disciplines.forEach((d) => {
        const disciplineName = tools.getTranslation(d.discipline, 'name', lang)
        disciplines.push(disciplineName)
      })
      return disciplines
    } else {
      return [vm.$t('service.no_discipline')]
    }
  },

  getServiceDisciplinesOrPracticeStyles(item, lang, vm) {
    if (item && item.disciplines && item.disciplines.length > 0) {
      const disciplines = []
      item.disciplines.forEach((d) => {
        let disciplineName = ''
        if (d.practiceStyle) {
          disciplineName = tools.getTranslation(d.practiceStyle, 'name', lang)
        } else {
          disciplineName = tools.getTranslation(d.discipline, 'name', lang)
        }
        disciplines.push(disciplineName)
      })
      return disciplines
    } else {
      return [vm.$t('service.no_discipline')]
    }
  },

  getBlogImage(blog) {
    if (blog.images && blog.images[0])
      return blog.images[0].webPath.replace('http:', 'https:')
    else return require('~/static/img/blog-default.jpg')
  },

  getSessionLink(session, theme, lang, reserve) {
    const slug = (
      session.planning.service.translations.find((l) => l.lang === lang) ||
      session.planning.service.translations[0]
    ).slug
    let path =
      this.getSaasBaseUrl(theme) +
      lang +
      '/' +
      this.getCategory(theme) +
      '/' +
      slug +
      '/' +
      session.planning.service.id
    if (reserve) path += '/reserve'
    path += '?session=' + session.id
    return path
  },

  getSessionImage(session, theme) {
    let image = tools.getDefaultThemeImage(theme)
    if (_.has(session, 'planning.service.images')) {
      image = _.has(session.planning.service.images[0], 'webPath')
        ? session.planning.service.images[0].webPath.replace('http', 'https')
        : image
    } else if (_.has(session, 'place.images')) {
      image = _.has(session.place.images[0], 'webPath')
        ? session.place.images[0].webPath.replace('http', 'https')
        : image
    }
    return image
  },

  //  getDefaultThemeImage(theme) {
  //    let image = require('~/static/images/goyoga/goyoga-default.jpg')
  //    if(theme == 'gopilates') {
  //      require('~/static/images/gopilates/gopilates-default.jpg')
  //    } else if(theme == 'gotherapy') {
  //      require('~/static/images/gotherapy/gotherapy-default.jpg')
  //    }
  //    return image
  //  },

  getTeacherLink(slug, id, lang, theme = 'goyoga', isWL = false) {
    return this.getSaasBaseUrl(theme) + lang + '/p/' + slug + '/' + id
  },

  getTeacherImage(item) {
    if (item && item.avatar && item.avatar.webPath) {
      return item.avatar.webPath.replace('http', 'https')
    } else if (item && item.avatar && item.avatar.filePath) {
      return item.avatar.filePath.replace('http', 'https')
    } else {
      let teacher = {}
      if (item && item.teacher) teacher = item.teacher
      else teacher = item
      if (
        teacher &&
        teacher.user &&
        teacher.user.avatar &&
        teacher.user.avatar.webPath.replace('http', 'https')
      ) {
        return teacher.user.avatar.webPath.replace('http', 'https')
      } else {
        return require('../static/img/user/user_gy.svg')
      }
    }
  },

  getTeacherDisciplines(item, lang, vm) {
    if (item && item.disciplines && item.disciplines.length > 0) {
      const disciplines = []
      item.disciplines.forEach((d) => {
        const disciplineName = tools.getTranslation(d.discipline, 'name', lang)
        disciplines.push(disciplineName)
      })
      return disciplines
    } else {
      return [vm.$t('account.teacher.no_discipline')]
    }
  },

  getTeacherName(item) {
    if (item) {
      let teacher = {}
      if (item.teacher) teacher = item.teacher
      else teacher = item
      return tools.getUserName(teacher.user)
    } else return ''
  },

  removeDuplicateTeachers(val) {
    const value = []
    Object.assign(value, val)
    for (let i = 0; i < value.length; i++) {
      const teacher = value[i]
      if (!teacher.user)
        teacher.user = teacher.teacher ? teacher.teacher.user : {}
      if (!teacher.disciplines)
        teacher.disciplines = teacher.teacher ? teacher.teacher.disciplines : []
      for (let j = i + 1; j < value.length; j++) {
        const teacher2 = value[j]
        if (!teacher2.user)
          teacher2.user = teacher2.teacher ? teacher2.teacher.user : {}
        if (!teacher2.disciplines)
          teacher2.disciplines = teacher2.teacher
            ? teacher2.teacher.disciplines
            : []
        if (teacher.user.id === teacher2.user.id) {
          value.splice(j, 1)
        }
      }
    }
    return value
  },

  getTeachersByDiscipline(teachers, vm) {
    const disciplines = {
      Yoga: {
        name: vm.$t('common.yoga_teachers'),
        teachers: []
      },
      thérapeute: {
        name: vm.$t('common.therapists'),
        teachers: []
      },
      Pilates: {
        name: vm.$t('common.pilates_teachers'),
        teachers: []
      },
      Coach: {
        name: vm.$t('common.coachs'),
        teachers: []
      },
      unknown: {
        name: vm.$t('common.unknowns'),
        teachers: []
      }
    }

    // TODO: Remove this code when api don't send duplicates
    teachers = tools.removeDuplicateTeachers(teachers)

    teachers.forEach((currentTeacher) => {
      let teacher = {}
      if (currentTeacher.teacher) {
        teacher = JSON.parse(JSON.stringify(currentTeacher.teacher))
      } else {
        teacher = JSON.parse(JSON.stringify(currentTeacher))
      }

      teacher.disciplines.forEach((discipline) => {
        const dsp = JSON.parse(JSON.stringify(discipline))
        switch (discipline.discipline.id) {
          case process.env.YOGA_DISCIPLINE:
            disciplines.Yoga.teachers.push({ ...teacher, dsp })
            break
          case process.env.PILATES_DISCIPLINE:
            disciplines.Pilates.teachers.push({ ...teacher, dsp })
            break
          case process.env.THERAPIST_DISCIPLINE:
            disciplines['thérapeute'].teachers.push({ ...teacher, dsp })
            break
          case process.env.COACH_DISCIPLINE:
            disciplines.Coach.teachers.push({ ...teacher, dsp })
            break
          default:
            disciplines.unknown.teachers.push({ ...teacher, dsp })
            break
        }
      })
    })

    return disciplines
  },

  getTeachersWithDiscipline(val, vm) {
    const teachers = {
      unknown: [],
      Yoga: [],
      Pilates: [],
      thérapeute: [],
      Coach: []
    }

    // TODO: Remove this code when api don't send duplicates
    const value = tools.removeDuplicateTeachers(val)

    for (let i = 0; i < value.length; i++) {
      let teacher = value[i]

      if (!teacher.user)
        teacher.user = teacher.teacher ? teacher.teacher.user : {}
      if (!teacher.disciplines)
        teacher.disciplines = teacher.teacher ? teacher.teacher.disciplines : []

      if (teacher.disciplines) {
        for (let j = 0; j < teacher.disciplines.length; j++) {
          const dsp = JSON.parse(JSON.stringify(teacher.disciplines[j]))

          switch (dsp.discipline.id) {
            case process.env.YOGA_DISCIPLINE:
              teacher = {
                ...teacher,
                dspName: vm.$t('common.yoga_teacher'),
                dspImg:
                  dsp.images && dsp.images[dsp.images.length - 1]
                    ? dsp.images[dsp.images.length - 1].webPath.replace(
                        'http',
                        'https'
                      )
                    : '',
                dsp
              }
              teachers.Yoga.push(teacher)
              break
            case process.env.PILATES_DISCIPLINE:
              teacher = {
                ...teacher,
                dspName: vm.$t('common.pilates_teacher'),
                dspImg:
                  dsp.images && dsp.images[dsp.images.length - 1]
                    ? dsp.images[dsp.images.length - 1].webPath.replace(
                        'http',
                        'https'
                      )
                    : '',
                dsp
              }
              teachers.Pilates.push(teacher)
              break
            case process.env.THERAPIST_DISCIPLINE:
              teacher = {
                ...teacher,
                dspName: vm.$t('common.therapist'),
                dspImg:
                  dsp.images && dsp.images[dsp.images.length - 1]
                    ? dsp.images[dsp.images.length - 1].webPath.replace(
                        'http',
                        'https'
                      )
                    : '',
                dsp
              }
              teachers['thérapeute'].push(teacher)
              break
            case process.env.COACH_DISCIPLINE:
              teacher = {
                ...teacher,
                dspName: vm.$t('common.coach'),
                dspImg:
                  dsp.images && dsp.images[dsp.images.length - 1]
                    ? dsp.images[dsp.images.length - 1].webPath.replace(
                        'http',
                        'https'
                      )
                    : '',
                dsp
              }
              teachers.Coach.push(teacher)
              break
            default:
              teacher = {
                ...teacher,
                dspName: dsp.discipline.translations[0].name,
                dspImg:
                  dsp.images && dsp.images[dsp.images.length - 1]
                    ? dsp.images[dsp.images.length - 1].webPath.replace(
                        'http',
                        'https'
                      )
                    : '',
                dsp
              }
              teachers.unknown.push(teacher)
              break
          }
        }
      } else teachers.unknown.push(teacher)
    }
    return [
      ...teachers.Yoga,
      ...teachers['thérapeute'],
      ...teachers.Pilates,
      ...teachers.Coach,
      ...teachers.unknown
    ]
  },

  getUserName(user) {
    if (user) {
      return (
        this.capitalize(user.firstName) + ' ' + this.capitalize(user.lastName)
      )
    } else {
      return null
    }
  },

  getUserImage(item) {
    if (item && item.avatar && item.avatar.webPath) {
      return item.avatar.webPath.replace('http', 'https')
    } else {
      return require('../static/img/user/user_gy.svg')
    }
  },

  getPlaceLink(place, lang, theme = 'goyoga') {
    if (place.translations && place.translations.length > 0) {
      return (
        this.getSaasBaseUrl(theme) +
        lang +
        '/l/' +
        (
          place.translations.find((t) => t.lang === lang) ||
          place.translations[0]
        ).slug +
        '/' +
        place.id
      )
    } else {
      return false
    }
  },

  getPlaceName(place, lang) {
    return this.capitalize(
      (place.translations.find((t) => t.lang === lang) || place.translations[0])
        .name
    )
  },

  getPlaceImage(place) {
    if (place && place.images && place.images.length > 0) {
      return place.images[0].webPath.replace('http:', 'https:')
    } else {
      return require('@/static/img/default_place.jpg')
    }
  },

  getPlaceAddress(place) {
    if (place) {
      const address = place.address
      let result = address.address ? address.address : ''
      result = address.zipCode ? result + ', ' + address.zipCode : result
      result = address.city ? result + ' ' + address.city : result
      result = address.country ? result + ', ' + address.country : result
      return result
    } else return ''
  },

  getDateTimeMoment(date, time, vm) {
    return vm
      .$moment(date, 'DD/MM/YY')
      .hours((time && time.substring(0, 2)) || '')
      .minutes((time && time.substring(3, 5)) || '')
  },

  isSessionMoreThanOneDay(dateFrom, timeFrom, duration, durationType, vm) {
    const durationTypes = ['minutes', 'hours', 'days']
    const dateBegin = this.getDateTimeMoment(dateFrom, timeFrom, vm)
    const dateEnd = dateBegin
      .clone()
      .add(duration, durationTypes[durationType - 1])
    return dateBegin.format('YYYY-MM-DD') !== dateEnd.format('YYYY-MM-DD')
  },

  getHumanizedDuration(duration, durationType, vm) {
    const durationTypes = ['minutes', 'hours', 'days']
    const durationMoment = vm.$moment.duration(
      duration,
      durationTypes[durationType - 1]
    )
    const minutesDuration = durationMoment.asMinutes()
    let format = ''
    if (minutesDuration < 60) {
      format = 'mm [mn]'
    } else if (minutesDuration < 1440) {
      format = 'h[h]mm'
    } else {
      format = 'd [' + vm.$t('common.days') + ']'
      if (durationMoment.format('h') > 0) {
        format += ' h [' + vm.$t('common.hours') + ']'
      }
      if (durationMoment.format('m') > 0) {
        format += ' m [' + vm.$t('common.minutes') + ']'
      }
    }
    return durationMoment.format(format)
  },

  getPlanningDesc(planning, vm) {
    const durationTypes = ['minutes', 'hours', 'days']
    const dateFrom = this.getDateTimeMoment(
      planning.dateFrom,
      planning.timeFrom ? planning.timeFrom : '00:00',
      vm
    )
    let desc = ''
    if (planning.repetitionService === 1) {
      // Planning not recurring
      if (
        this.isSessionMoreThanOneDay(
          planning.dateFrom,
          planning.timeFrom,
          planning.duration,
          planning.durationType,
          vm
        )
      ) {
        // Session on more than one day
        const dateFromStr = dateFrom.format('llll')
        dateFrom.add(
          planning.duration,
          durationTypes[planning.durationType - 1]
        )
        desc = vm.$t('planning.date_range', {
          dateFrom: dateFromStr,
          dateTo: dateFrom.format('llll')
        })
      } else {
        // Session on one day
        desc += dateFrom.format('LLLL')
      }
    } else {
      // Planning recurring
      if (planning.recurrence === 1) {
        desc += vm.$t('planning.recurrence_from', {
          dateFrom: dateFrom.format('LL')
        })
      } else if (planning.repetitionPeriod) {
        // Planning recurring period every year
        desc += vm.$t('planning.recurrence_period_every_year', {
          dateFrom: dateFrom.format(vm.$t('common.date_format3')),
          dateTo: planning.dateTo
        })
      } else {
        // Planning recurring period only this year
        const dateTo = this.getDateTimeMoment(planning.dateTo, '23:59', vm)
        desc += vm.$t('planning.recurrence_period_once', {
          dateFrom: dateFrom.format('LL'),
          dateTo: dateTo.format('LL')
        })
      }
      if (planning.serviceSchedules && planning.serviceSchedules.length > 0) {
        const timeFrom = planning.serviceSchedules[0].timeFrom
        const timeTo = planning.serviceSchedules[0].timeTo

        // Check to know if time slots
        let timeSlots = true
        planning.serviceSchedules.forEach((el) => {
          if (el.timeTo) {
            timeSlots = false
          }
        })

        // Check to know if same hours everyday day
        let identicalsHours = true
        if (!timeSlots) {
          planning.serviceSchedules.forEach((el) => {
            if (el.timeFrom !== timeFrom || el.timeTo !== timeTo) {
              identicalsHours = false
            }
          })
        }

        // Let manage the day's names
        const daysName = []
        planning.serviceSchedules.forEach((el) => {
          if (!daysName.includes(vm.$moment.weekdays()[el.dayOfWeek]))
            daysName.push(vm.$moment.weekdays()[el.dayOfWeek])
        })
        desc += ' ' + vm.$t('planning.on_days') + ' ' + daysName.join(', ')

        if (timeSlots) {
          // Time slots are same every days
          const times = []
          planning.serviceSchedules.forEach((el) => {
            if (!times.includes(el.timeFrom)) times.push(el.timeFrom)
          })

          desc += ' ' + vm.$t('planning.at_time') + ' ' + times.join(', ')
        } else if (identicalsHours) {
          // Same availability every day
          desc += ' ' + vm.$t('planning.time_period', { timeFrom, timeTo })
        } else {
          // Availability changes every day
          const daysPeriods = []
          planning.serviceSchedules.forEach((el) => {
            const dayPeriod = vm.$t('planning.day_period', {
              day: vm.$moment.weekdays()[el.dayOfWeek],
              timeFrom: el.timeFrom,
              timeTo: el.timeTo
            })
            daysPeriods.push(dayPeriod)
          })
          desc += ' : ' + daysPeriods.join(', ')
        }
      }
    }
    return desc
  },

  getWhiteMarkLink(center) {
    if (
      center.whiteMark &&
      center.whiteMark.subDomain &&
      center.whiteMark.domainName &&
      center.whiteMark.domainName.name
    )
      return (
        'https://' +
        center.whiteMark.subDomain +
        '.' +
        center.whiteMark.domainName.name
      )
    else return false
  },

  getCenterLink(center) {
    if (center.domainName && center.domainName.name && center.subDomain)
      return 'https://' + center.subDomain + '.' + center.domainName.name
    else return false
  },

  getCenterImage(center) {
    if (_.has(center, 'image') && _.has(center.image, 'webPath')) {
      return center.image.webPath.replace('http', 'https')
    } else {
      return require('~/static/img/service-default.jpg')
    }
  },

  getTrendLink(trend, theme, lang) {
    return (
      '/' +
      lang +
      '/' +
      this.getCategory(theme) +
      '/search-results?practiceTrend=' +
      trend.id
    )
  },

  getTrendName(trend, lang) {
    return (
      trend.translations.find((t) => t.lang === lang) || trend.translations[0]
    ).name
  },

  getLevelLink(level, theme, lang) {
    return (
      '/' +
      lang +
      '/' +
      this.getCategory(theme) +
      '/search-results?level=' +
      level.id
    )
  },

  getLevelName(level, theme, lang) {
    return (
      level.translations.find((t) => t.lang === lang) || level.translations[0]
    ).name
  },

  getCourseTypeLink(courseType, theme, lang) {
    return (
      '/' +
      lang +
      '/' +
      this.getCategory(theme) +
      '/search-results?courseType=' +
      courseType.id
    )
  },

  getCourseTypeName(courseType, theme, lang) {
    return this.capitalize(
      (
        courseType.translations.find((t) => t.lang === lang) ||
        courseType.translations[0]
      ).name
    )
  },

  getPracticeStyleLink(practiceStyle, theme, lang) {
    let link =
      '/' +
      lang +
      '/' +
      this.getCategory(theme) +
      '/search-results?practiceStyle=' +
      practiceStyle.id
    if (practiceStyle.translations && practiceStyle.translations.length > 0) {
      const name =
        (
          practiceStyle.translations.find((t) => t.lang === lang) ||
          practiceStyle.translations[0]
        ).name || ''
      if (name !== '') link += '&practiceStyleName=' + name
    }
    return link
  },

  getPracticeStyleName(practiceStyle, theme, lang) {
    return (
      practiceStyle.translations.find((t) => t.lang === lang) ||
      practiceStyle.translations[0]
    ).name
  },

  slugify(string) {
    const a =
      'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
    const b =
      'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return (
      string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        // eslint-disable-next-line
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        // eslint-disable-next-line
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '')
    ) // Trim - from end of text
  },

  capitalize(str) {
    if (str && str.length > 0) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    } else {
      return str
    }
  },

  stripHtml(html) {
    let result = html
    try {
      result = html.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '')
    } catch (error) {
      // eslint-disable-next-line
      console.log('error stripHtml: ' + JSON.stringify(error))
    }
    return result
  },

  updateRouter(params, vm) {
    const queryObj = JSON.parse(JSON.stringify(vm.$route.query))
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        queryObj[key] = value
      } else {
        vm.$delete(queryObj, key)
        vm.$delete(queryObj, `${key}Name`)
      }
    }
    // Update url
    vm.$router.replace({ query: queryObj })
  },

  wip(vm) {
    vm.$notify({
      message:
        vm.$t('common.work_in_progress_1') +
        ' ' +
        vm.$t('common.work_in_progress_2'),
      icon: 'warning',
      horizontalAlign: 'center',
      verticalAlign: 'top',
      type: 'warning'
    })
  },

  notifySuccess(vm) {
    vm.$notify({
      message: vm.$t('common.save_success'),
      icon: 'check_circle',
      horizontalAlign: 'center',
      verticalAlign: 'top',
      type: 'success'
    })
  },

  notifyMessage(message, vm) {
    vm.$notify({
      message,
      icon: 'info',
      horizontalAlign: 'center',
      verticalAlign: 'top',
      type: 'warning'
    })
  },

  notifyError(error, vm) {
    try {
      let errorMsg = error
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMsg = vm.$t('error.' + error.response.data.message)
      } else if (error && error.message) {
        errorMsg = vm.$t(error.message)
      }
      vm.$notify({
        message: vm.$t('common.save_error') + ' ' + errorMsg,
        icon: 'warning',
        horizontalAlign: 'center',
        verticalAlign: 'middle',
        type: 'danger'
      })
    } catch (e) {
      // eslint-disable-next-line
      console.log('error notifyError: ' + JSON.stringify(e))
    }
  },

  retrieveUserInformations(myCenters, vm) {
    const DEFAULT_CENTER_KEY = 'goyoga_manager_default_center'
    // Retrieve user last currentCenter
    const currentCenter =
      vm.$store.state.centerToken ||
      nuxtStorage.localStorage.getData(
        DEFAULT_CENTER_KEY +
          '_' +
          nuxtStorage.localStorage.getData('auth.user_id')
      )
    if (!currentCenter) {
      if (myCenters.length > 0) {
        nuxtStorage.localStorage.setData(
          DEFAULT_CENTER_KEY +
            '_' +
            nuxtStorage.localStorage.getData('auth.user_id'),
          myCenters[0].id
        )
        vm.setMyCurrentCenter(myCenters[0])
        vm.setCenterToken(myCenters[0].id)
      }
    } else {
      const center = myCenters.filter((c) => c.id === currentCenter)
      if (center.length) {
        nuxtStorage.localStorage.setData(
          DEFAULT_CENTER_KEY +
            '_' +
            nuxtStorage.localStorage.getData('auth.user_id'),
          center[0].id
        )
        vm.setMyCurrentCenter(center[0])
        vm.setCenterToken(center[0].id)
      } else if (myCenters.length > 0) {
        nuxtStorage.localStorage.setData(
          DEFAULT_CENTER_KEY +
            '_' +
            nuxtStorage.localStorage.getData('auth.user_id'),
          myCenters[0].id
        )
        vm.setMyCurrentCenter(myCenters[0])
        vm.setCenterToken(myCenters[0].id)
      } else {
        nuxtStorage.localStorage.setData(
          DEFAULT_CENTER_KEY +
            '_' +
            nuxtStorage.localStorage.getData('auth.user_id'),
          null
        )
        vm.setMyCurrentCenter(null)
        vm.setCenterToken(false)
      }
    }
  },

  getDateTime(date, time = null, format, vm) {
    const dateTime = vm.$moment(
      date,
      vm.$moment.HTML5_FMT.DATETIME_LOCAL_SECONDS
    )
    if (time) {
      dateTime.hour(time.substr(0, 2))
      dateTime.minute(time.substr(3, 4))
    }
    return dateTime.format(format)
  },

  addressToString(address) {
    if (address) {
      let result = address.address ? address.address : ''
      result = address.zipCode ? result + ', ' + address.zipCode : result
      result =
        address.zipCode && address.city ? result + ' ' + address.city : result
      result = address.country ? result + ', ' + address.country : result
      return result
    }
    return ''
  },

  getObjectIds(arrayData) {
    const ids = []
    if (arrayData && arrayData.length > 0) {
      arrayData.forEach((data) => {
        if (data.id) {
          ids.push(data.id)
        }
      })
    }
    return ids
  },

  getPlanningModelRecurring(planning, vm) {
    const model = {}
    let hasBattlements = 1
    if (
      planning &&
      planning.serviceSchedules &&
      planning.serviceSchedules.length > 0
    ) {
      planning.serviceSchedules.forEach((schedule) => {
        if (Object.prototype.hasOwnProperty.call(schedule, 'timeTo')) {
          hasBattlements = 0
        }
      })
    }
    if (hasBattlements === 0) {
      model.withInterval = planning.withInterval
      model.intervalDuration = planning.intervalDuration
    }
    model.dateFrom = planning.dateFrom
    model.recurrence = planning.recurrence
    if (model.recurrence === 2) {
      model.repetitionPeriod = planning.repetitionPeriod
      model.dateTo = planning.dateTo
    }
    model.duration = planning.duration
    model.durationType = planning.durationType || 1
    model.dayOff = planning.dayOff
    model.holiday = planning.holiday
    if (planning.serviceSchedules) {
      model.serviceSchedules = planning.serviceSchedules
    }
    return model
  },

  getCivility(civility, vm) {
    switch (civility) {
      case 1:
        return vm.$t('account.profile.civility.mr')
      case 2:
        return vm.$t('account.profile.civility.mrs')
      case 3:
        return vm.$t('account.profile.civility.ms')
      default:
        return ''
    }
  },

  getTeacherProfilePercent(user) {
    let percent = 0
    if (user && user.teacher) {
      user.teacher.address ? (percent += 25) : (percent += 0)
      user.teacher.languages ? (percent += 25) : (percent += 0)
      user.teacher.phone ? (percent += 25) : (percent += 0)
      user.teacher.facebook ||
      user.teacher.instagram ||
      user.teacher.twitter ||
      user.teacher.linkedin
        ? (percent += 25)
        : (percent += 0)
    }
    return percent
  },

  teacherDisciplinePercent(teacherDiscipline, fieldsList) {
    let expectedTotal = 0
    let disciplineTotal = 0
    if (teacherDiscipline) {
      // Images
      expectedTotal += 10
      teacherDiscipline.images
        ? teacherDiscipline.images.length >= 3
          ? (disciplineTotal += 10)
          : (disciplineTotal += 10 * (teacherDiscipline.images.length / 3))
        : (disciplineTotal += 0)
      // Diplomas
      expectedTotal += 10
      teacherDiscipline.diplomas && teacherDiscipline.diplomas.length > 0
        ? (disciplineTotal += 10)
        : (disciplineTotal += 0)
      // Qualities
      expectedTotal += 10
      teacherDiscipline.qualities && teacherDiscipline.qualities.length > 0
        ? (disciplineTotal += 10)
        : (disciplineTotal += 0)
      // CourseTYpes
      expectedTotal += 10
      teacherDiscipline.courseTypes && teacherDiscipline.courseTypes.length > 0
        ? (disciplineTotal += 10)
        : (disciplineTotal += 0)
      // Fields
      fieldsList.forEach((field) => {
        let fieldWeight = 10
        switch (field) {
          case 'citation':
            fieldWeight = 10
            break
          case 'description':
            fieldWeight = 20
            break
          case 'inspiration':
            fieldWeight = 10
            break
          case 'reference':
            fieldWeight = 10
            break
        }
        // Field fr
        expectedTotal += fieldWeight
        disciplineTotal +=
          (fieldWeight *
            this.getTranslationFieldPercent(teacherDiscipline, field, 'fr')) /
          100
        // Field en
        expectedTotal += fieldWeight
        disciplineTotal +=
          (fieldWeight *
            this.getTranslationFieldPercent(teacherDiscipline, field, 'en')) /
          100
      })
    }
    return expectedTotal > 0
      ? parseFloat(
          (parseFloat(disciplineTotal / expectedTotal) * 100).toFixed(2)
        )
      : 0
  },

  getTranslationFieldPercent(obj, field, language) {
    const countWords = this.countWords(
      this.getTranslationExactLanguage(obj, field, language)
    )
    let expectedWords = 1
    switch (field) {
      case 'name':
        expectedWords = 1
        break
      case 'citation':
        expectedWords = 30
        break
      case 'description':
        expectedWords = 300
        break
      case 'inspiration':
        expectedWords = 50
        break
      case 'reference':
        expectedWords = 50
        break
    }
    const percent = countWords / expectedWords
    return percent > 1 ? 100 : percent * 100
  },
  countWords(str) {
    if (str) {
      return str.trim().split(/\s+/).length
    } else return 0
  },
  placePercent(place) {
    let expectedTotal = 0
    let placeTotal = 0
    if (place) {
      // Images
      expectedTotal += 10
      place.images
        ? place.images.length >= 3
          ? (placeTotal += 10)
          : (placeTotal += 10 * (place.images.length / 3))
        : (placeTotal += 0)
      // Capacity
      expectedTotal += 10
      place.capacity > 0 ? (placeTotal += 10) : (placeTotal += 0)
      // ContactName
      expectedTotal += 10
      place.contactName && place.contactName.length > 0
        ? (placeTotal += 10)
        : (placeTotal += 0)
      // ContactPhone
      expectedTotal += 10
      place.contactPhone && place.contactPhone.length > 0
        ? (placeTotal += 10)
        : (placeTotal += 0)
      // PlaceType
      expectedTotal += 10
      place.placeType && place.placeType.id
        ? (placeTotal += 10)
        : (placeTotal += 0)
      // Address
      expectedTotal += 10
      place.address && place.address.id ? (placeTotal += 10) : (placeTotal += 0)
      // EnergySources
      expectedTotal += 10
      place.energySources && place.energySources.length > 0
        ? (placeTotal += 10)
        : (placeTotal += 0)
      // PlaceAccesses
      expectedTotal += 10
      place.placeAccesses && place.placeAccesses.length > 0
        ? (placeTotal += 10)
        : (placeTotal += 0)
      // PlaceOptions
      expectedTotal += 10
      place.placeOptions && place.placeOptions.length > 0
        ? (placeTotal += 10)
        : (placeTotal += 0)
      // Fields
      const fieldsList = ['name', 'description']
      fieldsList.forEach((field) => {
        let fieldWeight = 10
        switch (fieldsList) {
          case 'name':
            fieldWeight = 10
            break
          case 'description':
            fieldWeight = 20
            break
        }
        // Field fr
        expectedTotal += fieldWeight
        placeTotal +=
          (fieldWeight * this.getTranslationFieldPercent(place, field, 'fr')) /
          100
        // Field en
        expectedTotal += fieldWeight
        placeTotal +=
          (fieldWeight * this.getTranslationFieldPercent(place, field, 'en')) /
          100
      })
    }
    return expectedTotal > 0
      ? parseFloat((parseFloat(placeTotal / expectedTotal) * 100).toFixed(2))
      : 0
  },
  servicePercent(service) {
    let expectedTotal = 0
    let serviceTotal = 0
    if (service) {
      // Check is published
      //      if (!(service.statusDetails && service.statusDetails.published)) {
      //        return 0
      //      }
      // Images
      expectedTotal += 10
      service.images
        ? service.images.length >= 5
          ? (serviceTotal += 10)
          : (serviceTotal += 10 * (service.images.length / 5))
        : (serviceTotal += 0)
      // Minimum 1 coming session
      expectedTotal += 10
      service.countComingSessions > 0
        ? (serviceTotal += 10)
        : (serviceTotal += 0)
      // Languages
      expectedTotal += 10
      service.languages && service.languages.length > 0
        ? (serviceTotal += 10)
        : (serviceTotal += 0)
      // Disciplines
      expectedTotal += 10
      service.disciplines && service.disciplines.length > 0
        ? (serviceTotal += 10)
        : (serviceTotal += 0)
      // Plannings
      expectedTotal += 10
      service.plannings && service.plannings.length > 0
        ? (serviceTotal += 10)
        : (serviceTotal += 0)
      // Fields
      const fieldsList = ['name', 'description']
      fieldsList.forEach((field) => {
        let fieldWeight = 10
        switch (field) {
          case 'name':
            fieldWeight = 10
            break
          case 'description':
            fieldWeight = 50
            break
        }
        // Field fr
        expectedTotal += fieldWeight
        serviceTotal +=
          (fieldWeight *
            this.getTranslationFieldPercent(service, field, 'fr')) /
          100
        // Field en
        expectedTotal += fieldWeight
        serviceTotal +=
          (fieldWeight *
            this.getTranslationFieldPercent(service, field, 'en')) /
          100
      })
    }
    return expectedTotal > 0
      ? parseFloat((parseFloat(serviceTotal / expectedTotal) * 100).toFixed(2))
      : 0
  },
  getPaymentMethod(method, vm) {
    switch (method) {
      case 1:
        return vm.$t('common.payment_method_cb')
      case 2:
        return vm.$t('common.payment_method_sepa')
      case 3:
        return vm.$t('common.payment_method_cheque')
      case 4:
        return vm.$t('common.payment_method_cash')
      case 5:
        return vm.$t('common.payment_method_tpe')
    }
  },
  formatCurrency(value, vm = null) {
    if (typeof value !== 'number') {
      return value
    }
    const locale = vm ? vm.$i18n.locale : 'fr-FR'
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    })
    return formatter.format(value)
  }
}
